<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/x4kWwe/tc-custom/9781637152560.jpg?1712805179626" alt="This image is the cover for the book Rick and Morty Compendium Vol. 1, Rick and Morty"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Rick and Morty Compendium Vol. 1, Rick and Morty
      </h1>
      <p class="bookDescription body article font2">
        <p>Go back to where it all started with this giant-sized, 300+ page softcover collection of Rick and Morty’s best-selling comic book adventures! Irreverent but incomparable genius Rick Sanchez travels across time and reality on hilarious (and harrowing) adventures with his awkward, 14-year-old grandson Morty. Featuring the classic stories “Wubba Lubba Dub Dub of Wall Street” by Zac Gorman and CJ Cannon, “Ball Fondlers Special” by Gorman and Andrew MacLean, “Ready Player Morty” by Pamela Ribon and Marc Ellerby, and more tales of chaos and debauchery with the whole Smith family. Collecting Rick and Morty (2015) #1–15!</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Zac Gorman, CJ Cannon, Ryan Hill, Crank!
      </h2>
      
      <p class="authorDescription body article">Zac Gorman is a cartoonist from Detroit, Michigan, raised on the sacred suburban triumvirate of video games, cartoons, and comic books. He's the creator of the popular webcomic Magical Game Time and has worked on several animated television series as a storyboard artist and character designer. Zach currently resides in Chicago with his far-more-talented wife and a furry little monster who most people mistake for a cat.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Oni Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?3eb37588